import { moduleRouteDictionaryFactory } from '@tundr/routing';
import { bankTransfersRoutesDictionary } from '@bo/modules/app/bank-transfers/routes/bank-transfers-routes.dictionary.ts';
import { billingRoutesDictionary } from '@bo/modules/app/billing/routes/billing-routes.dictionary.ts';
import { cardOrderRoutesDictionary } from '@bo/modules/app/card-orders/routes/card-order-routes.dictionary.ts';
import { companyRoutesDictionary } from '@bo/modules/app/company/routes/company-routes.dictionary.ts';
import { overBudgetEmployeeRoutesDictionary } from '@bo/modules/app/over-budget-employee/routes/over-budget-employee.dictionary.ts';
import { paymentValidationKeywordsRoutesDictionary } from '@bo/modules/app/payment-validation-keywords/routes/payment-validation-keywords-routes.dictionary.ts';
import { paymentsRoutesDictionary } from '@bo/modules/app/payments/routes/payments-routes.dictionary.ts';
import { pensionFundRoutesDictionary } from '@bo/modules/app/pension-funds/routes/pension-fund-routes.dictionary.ts';
import { reimbursementRoutesDictionary } from '@bo/modules/app/reimbursement/routes/reimbursement-routes.dictionary.ts';
import { subscriptionRoutesDictionary } from '@bo/modules/app/subscription/routes/subscription-routes.dictionary.ts';
import { supplierVouchersRoutesDictionary } from '@bo/modules/app/supplier-voucher-reports/routes/supplier-vouchers-routes.dictionary.ts';
import { suppliersRoutesDictionary } from '@bo/modules/app/suppliers/routes/suppliers-routes.dictionary.ts';
import { usersRoutesDictionary } from '@bo/modules/app/users/routes/users-routes.dictionary.ts';
import { authRoutesDictionary } from '@bo/modules/auth/routes/auth-routes.dictionary';
import { fringeRoutesDictionary } from './../../modules/app/fringe/routes/fringe-routes.dictionary';
import { reportsRoutesDictionary } from './../../modules/app/reports/routes/reports-routes.dictionary.ts';
import { vouchersRoutesDictionary } from '@bo/modules/app/vouchers/routes/vouchers-routes.dictionary.ts';
import { mealVouchersRoutesDictionary } from '@bo/modules/app/meal-vouchers/routes/meal-vouchers-routes.dictionary.ts';
import { depositRoutesDictionary } from '@bo/modules/app/deposit/routes/deposit-routes.dictionary.ts';
import { brandsRoutesDictionary } from '@bo/modules/app/brands/routes/brands-routes.dictionary.ts';
import { resellerRoutesDictionary } from '@bo/modules/app/reseller/routes/reseller-routes.dictionary.ts';
import { voucherCodesMonitorRoutesDictionary } from '@bo/modules/app/voucher-codes-monitor/routes/voucher-codes-monitor-routes.dictionary.ts';
import { healthFundRoutesDictionary } from '@bo/modules/app/health-funds/routes/health-fund-routes.dictionary.ts';
import { welfareAssignmentsRoutesDictionary } from '@bo/modules/app/welfare-assignments/routes/welfare-assignments-routes.dictionary.ts';
import { reversalRoutesDictionary } from '@bo/modules/app/reversal/routes/reversal-routes.dictionary.ts';
import { completePlanReversalRoutesDictionary } from '@bo/modules/app/reversal/routes/complete-plan-reversal-routes.dictionary.ts';

const rootRoutesDictionary = moduleRouteDictionaryFactory('root', '/', {
  notFound: '/:pathMatch(.*)*',
  app: '/app',
});

export const appRoutesDictionary = {
  ...rootRoutesDictionary,
  ...authRoutesDictionary,
  ...suppliersRoutesDictionary,
  ...companyRoutesDictionary,
  ...reportsRoutesDictionary,
  ...reimbursementRoutesDictionary,
  ...bankTransfersRoutesDictionary,
  ...subscriptionRoutesDictionary,
  ...overBudgetEmployeeRoutesDictionary,
  ...billingRoutesDictionary,
  ...fringeRoutesDictionary,
  ...paymentsRoutesDictionary,
  ...cardOrderRoutesDictionary,
  ...usersRoutesDictionary,
  ...supplierVouchersRoutesDictionary,
  ...paymentValidationKeywordsRoutesDictionary,
  ...pensionFundRoutesDictionary,
  ...vouchersRoutesDictionary,
  ...mealVouchersRoutesDictionary,
  ...depositRoutesDictionary,
  ...brandsRoutesDictionary,
  ...resellerRoutesDictionary,
  ...voucherCodesMonitorRoutesDictionary,
  ...healthFundRoutesDictionary,
  ...welfareAssignmentsRoutesDictionary,
  ...reversalRoutesDictionary,
  ...completePlanReversalRoutesDictionary,
};
